import axios from '@/utils/api'
import modulo from '@/utils/modulo'

const URL_DOCUMENTO_ASSINATURA = `${modulo.ASSINATURA}/documentos`

const getPathDownload = (fileKey, id) => {
  return fileKey ? `fileKey=${fileKey}` : `id=${id}`
}

const actions = {
  async save ({ commit }, dados) {
    const data = await axios({
      method: 'post',
      data: dados,
      url: URL_DOCUMENTO_ASSINATURA
    })

    return data
  },

  async find ({ commit }, filtro) {
    const data = await axios({
      method: 'post',
      url: `${URL_DOCUMENTO_ASSINATURA}/findByFilter`,
      data: filtro
    })
    return data
  },

  async findAssinaveis ({ commit }, filtro) {
    const data = await axios({
      method: 'post',
      url: `${URL_DOCUMENTO_ASSINATURA}/findAllAssinaveis`,
      data: filtro
    })

    return data
  },

  findById ({ commit }, id) {
    return axios({
      method: 'get',
      url: `${URL_DOCUMENTO_ASSINATURA}?id=${id}`,
      error: true
    })
  },

  download ({ commit }, { fileKey, id }) {
    return axios({
      method: 'get',
      responseType: 'arraybuffer',
      url: `${URL_DOCUMENTO_ASSINATURA}/download?${getPathDownload(fileKey, id)}`
    })
  },

  assinar ({ commit }, dados) {
    return axios({
      method: 'post',
      config: {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      },
      url: `${URL_DOCUMENTO_ASSINATURA}/assinar`,
      data: dados,
      error: true
    })
  },

  assinarTodos ({ commit }, dados) {
    return axios({
      method: 'post',
      url: `${URL_DOCUMENTO_ASSINATURA}/assinarTodos`,
      data: dados,
      error: true
    })
  },

  excluirDocumento ({ commit }, id) {
    return axios({
      method: 'delete',
      url: `${URL_DOCUMENTO_ASSINATURA}/excluir?id=${id}`,
      error: true
    })
  },

  vincular ({ commit }, dado) {
    return axios({
      method: 'post',
      url: `${URL_DOCUMENTO_ASSINATURA}/vincular/${dado.id}/${dado.idDoc}`,
      error: true
    })
  },

  hasProcessoVinculado ({ commit }, idDocumento) {
    return axios({
      method: 'get',
      url: `${URL_DOCUMENTO_ASSINATURA}/hasProcessoVinculado/${idDocumento}`,
      error: true
    })
  }
}

export default {
  namespaced: true,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/assinatura/documentoAssinatura.js